import * as React from 'react'
import classNames from 'classnames'
import './spinner.scss'

interface ISpinnerProps {
  className?: string
  style?: React.CSSProperties
}

/**
 * Displays a spinning loading icon.
 */
const Spinner = (props: ISpinnerProps): React.ReactElement<HTMLDivElement> => {
  return (
    <div className={classNames('loading-wrapper', props.className)} style={props.style}>
      <div className='loading-wrapper__spinner'></div>
    </div>
  )
}

export { Spinner }
